(function () {
	'use strict';

	angular.module('app.core')
		.service('$experiments', experimentService);

	experimentService.$inject = ['localStorageService'];

	function experimentService(localStorageService) {

		var OBSERVED_LEAD_TIME_USER_NDXS = new Set([1359,1395,7992,33596,33601,42139,44226,44238,46824,50081,50939,50951,52690,54779,56173,57861,59882,61101,61274,61892,64276,64379,64624,64625,64626,66071,69371]);
		var ROOT_CAUSE_CATEGORY_USER_NDXS = new Set([1359,33601,54450,54449,59461,69300,66072,69927,63987,54451,55939,68657,59595,29647,61635,21923,60414,61770,13267,21920,60415,23810,59733,61589]);

		function isCustomer(id) {
			return globalConfig.customer.id === id;
		}

		function isCustomerFromArray(ids) {
			return !!ids.filter(isCustomer).length;
		}

		var defaultFeatures = globalConfig.defaultFeatures;
		defaultFeatures['chat-enabled'] = globalConfig.customer.isChatEnabled;

		window.featureToggle = toggle;
		window.featureEnable = function (feature) { set(feature, true); };
		window.featureDisable = function (feature) { set(feature, false); };
		window.featuresEnabled = getFeatures;

		return {
			set: set,
			toggle: toggle,
			isEnabled: isEnabled,
			getAll: getFeatures,
			defaultFeatures: defaultFeatures,
			isLeanOnly: isLeanOnly
		};

		function isEnabled(feature) {
			var features = getFeatures();
			return !!features[feature];
		}

		function isLeanOnly() {
			return globalConfig.user.isLeanOnly;
		}


		function toggle(feature) {
			set(feature, !isEnabled(feature));
		}

		function set(feature, enabled) {
			var features = getFeatures();
			features[feature] = !!enabled;
			var savedFeatures = localStorageService.get('features') || {};
			savedFeatures[feature] = features[feature];
			localStorageService.set('features', JSON.stringify(savedFeatures));
		}

		function getFeatures() {
			var features = defaultFeatures;
			try {
				features = _.merge(features, localStorageService.get('features'));
			} finally {
				return features;
			}
		}
	}
})();
